import { z } from "zod";

export const staffSchema = z
  .object({
    firstName: z
      .string()
      .trim()
      .min(1, "First name is required")
      .max(30, "Maximum 30 characters is allowed!"),
    lastName: z
      .string()
      .trim()
      .min(1, "Last name is required")
      .max(30, "Maximum 30 characters is allowed!"),
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter a valid email address"),
    phone: z
      .string()
      .min(1, "Phone number is required")
      .refine(
        (val) => {
          const clean = val.replace(/\D/g, "");
          return clean.length >= 10 && clean.length <= 15;
        },
        {
          message: "Phone number must be between 10 and 15 digits",
        },
      ),
    position: z.string().optional(),
    teams: z.array(z.string()).optional(),
    role: z.enum(["staff", "frontdesk"]).default("staff"),
    customRoleId: z.string().optional(),
    password: z.string().optional(),
    photoId: z.string(),
    preferredLanguage: z.string().optional(),
  })
  .superRefine((data, context) => {
    if (data.role === "staff" && !data.position?.trim()) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["position"],
        message: "Position is required",
      });
    }

    if (data.role !== "frontdesk") return;

    if (!data.customRoleId) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["customRoleId"],
        message: "Frontdesk custom role is required",
      });
    }
    if (!data.password || data.password.length < 8) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["password"],
        message: "Password must contain at least 8 characters",
      });
    }
  });

export type StaffFormData = z.infer<typeof staffSchema>;

export const getTeamPlaceholder = (
  selectedTeamIds: string[] | undefined,
): string => {
  const count = selectedTeamIds?.length ?? 0;
  if (count > 0) {
    return `${count} ${count > 1 ? "teams" : "team"} selected`;
  }
  return "Select teams";
};
